import React from 'react';
import { useColorScheme } from '@mui/joy/styles';
import { ToastContainer } from 'react-toastify';
import { resolveColorMode } from '../theme/colorMode';

const ThemedToastContainer = () => {
  const { mode, systemMode } = useColorScheme();
  const resolvedMode = resolveColorMode(mode, systemMode);
  const theme = resolvedMode === 'dark' ? 'dark' : 'light';
  const modeClassName = `app-toast app-toast--${theme}`;
  const bodyModeClassName = `app-toast-body app-toast-body--${theme}`;
  const progressModeClassName = `app-toast-progress app-toast-progress--${theme}`;

  return (
    <ToastContainer
      theme={theme}
      toastClassName={modeClassName}
      bodyClassName={bodyModeClassName}
      progressClassName={progressModeClassName}
    />
  );
};

export default ThemedToastContainer;
